import type { IUseCase } from '@/shared/contracts/use-case.contract';

import { UIError } from '@/shared/utils/ui-error';
import type { IHttpClient } from '@/shared/contracts/http-client.contract';

import { HttpMethod } from '@/shared/contracts/http-client.contract';
import { ENDPOINT } from '../types/get-order';

import type { Response } from '../types/get-order';

type UseCaseInput = {
  id_order: string;
};

type UseCaseOutput = Response;

export class GetOrderUseCase implements IUseCase<UseCaseInput, UseCaseOutput> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute(input: UseCaseInput): Promise<UseCaseOutput> {
    const { id_order } = input;

    if (!id_order) {
      throw new UIError('ORDER_NOT_FOUND', 'Pedido não encontrado.');
    }

    console.log(id_order);

    return this.client.sendRequest<UseCaseOutput, UseCaseInput>({
      endpoint: `${ENDPOINT}/${id_order}`,
      method: HttpMethod.GET,
    });
  }
}
